export enum CommonPaths {
  ClosedAccount = '/dashboard/closed-account',
  InactiveAccount = '/dashboard/inactive-account',
  FirstTimeDeposit = '/profile/first-time-deposit',
  SignupFirstTimeDeposit = '/sign-up/first-time-deposit',
  AccountLoading = '/account-loading',
  AccountPending = '/account-pending',
  AccountNewPassword = '/account-password',
  DocumentManagement = '/profile/document-management',
  Sumsub = '/profile/verification',
  IntroducingBrokerWallets = '/dashboard/introducing-broker/wallets',
  IntroducingBrokerDashboard = '/dashboard/introducing-broker/dashboard',
  IntroducingBrokerClients = '/dashboard/introducing-broker/reports/clients',
  IntroducingBrokerIncome = '/dashboard/introducing-broker/reports/income',
  IntroducingBrokerReports = '/dashboard/introducing-broker/reports/ib-reports',
  IntroducingBrokerTransactionHistory = '/dashboard/introducing-broker/reports/transactions-history',
  IntroducingBrokerReferralMaterials = '/dashboard/introducing-broker/referral-materials',
  IntroducingBrokerLegalDocuments = '/dashboard/introducing-broker/legal-documents',
  IntroducingBrokerSignUp = '/dashboard/introducing-broker/sign-up',
  PaymentAgentWallets = '/dashboard/payment-agent/wallets',
  PaymentAgentTransactionHistory = '/dashboard/payment-agent/transaction-history',
  TradersRoomWallets = '/dashboard/traders-room/wallets',
  TradersRoomTradingAccounts = '/dashboard/traders-room/trading-accounts',
  TradersRoomTransactionHistory = '/dashboard/traders-room/transaction-history',
  Deposit = '/dashboard/traders-room/deposit',
  PaymentAgentDeposit = '/dashboard/payment-agent/deposit',
  TradersRoomBalances = '/dashboard/traders-room/balances',
  SubscriptionsPlatforms = '/dashboard/subscriptions/trading-platforms',
  SubscriptionsMarketData = '/dashboard/subscriptions/market-data',
  SubscriptionsHistory = '/dashboard/subscriptions/history',
  ETDStatements = '/dashboard/statements/daily',
  Dashboard = '/dashboard',
  ProductRegistrationLegalDocs = '/dashboard/product-registration/legal-documents',
  KycUpdateDetails = '/profile/kyc-update-details',
  KycUpdateSuccess = '/profile/kyc-update-details/success',
  ProductKycSuccess = '/dashboard/product-registration/kyc-personal-details/success',
  PasswordCompromised = '/password-compromised',
  Markets = '/dashboard/trade/markets',
  NewLiveTradingAccount = '/dashboard/traders-room/trading-accounts/live/new',
  NewDemoTradingAccount = '/dashboard/traders-room/trading-accounts/demo/new',
}
